import { createApp } from 'vue'
import $ from 'jquery'
window.$ = window.jQuery = $
import lodash from 'lodash'
window._ = lodash

import moment from 'moment'

// load bootstrap JS libraries
require('bootstrap')

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import axios from 'axios'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'

const oktaAuth = new OktaAuth({
  clientId: window.__env.CLIENT_ID,
  issuer: window.__env.ISSUER,
  redirectUri: `${window.location.origin}/web/login/callback`,
  scopes: window.__env.SCOPES,
  pkce: true,
  tokenManager: {
    storage: 'sessionStorage'
  },
})

import App from './App.vue'
import router from './router'
import store from './store'

const app = createApp(App)
  .use(router)
  .use(store)
  .use(OktaVue, {
    oktaAuth
  })

app.component('Datepicker', Datepicker);

var service = axios.create({
  baseURL: window.__env.API_URL,
  headers: {'Content-Type': 'application/json'},
  validateStatus(status) {
    return true
  },
});

service.interceptors.request.use(function (config) {
  let token = app.config.globalProperties.$auth.getAccessToken()
  config.headers['Authorization'] = `Bearer ${token}`
  return config
})

app.config.globalProperties.$http = service
store.$http = service

// Start the app
app.mount("#app")
